<template>
  <div :class="getClass">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Cards',
  props: {
    cols: {
      type: String,
      default: '3'
    }
  },
  methods: {
    hasForthSlot() {
      return !!this.$slots.four
    }
  },
  computed: {
    getClass() {
      return `cards cards--${this.cols}-col`
    }
  }
}
</script>

<style lang="postcss">
.cards {
  @apply flex -mx-6 overflow-x-scroll scrolling-touch;
}
.cards > div:first-child {
  @apply pl-6;
}
.cards > div:last-child {
  @apply pr-6;
}
@screen lg {
  .cards > div:first-child {
    @apply pl-4;
  }
  .cards > div:last-child {
    @apply pr-4;
  }
  .cards {
    @apply -mx-4 overflow-visible -mb-6 flex-wrap;
  }
}
</style>